import React, { useContext, useEffect, useState, useRef } from "react";
import { navigate } from "gatsby";
import { CircularProgress } from "@mui/material";
import GlobalContext from "../../../contexts/globalContext";
import rawToReact from "../../../utils/rawToReact";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import moment from "moment";

// Components //
import {FormTallerAprendizajeQuery} from "./queriesContentful/FormTallerAprendizajeQuery";
import Modal from "../../ui/modal/Modal";
import Button from "../../atoms/button/button";
import FormHead from "../../molecules/form-head/FormHead";
import FormBody from "../../molecules/form-body/FormBody";

// Services //
import getSchedulingMentoria from "../../../services/mentoriaSiseService";
import { getMunicipalities, getAllDepartments } from "../../../services/municipalities";
import { saveForm, getToken, getUserFormDataByQuestionId } from "../../../services/formServices";

// Helpers //
import { isDateMoreThanXMonthsAgo } from "../../../utils/helpers";

// Styles //
import "./FormTallerAprendizaje.scss";
import iconInfo from '../../../assets/images/icons/icon-lilac.svg';

const FormTallerAprendizaje = () =>{

    const data = FormTallerAprendizajeQuery();
    const listCityAmva = [
        "Medellin",
        "Barbosa",
        "Bello",
        "Caldas",
        "Copacabana",
        "Envigado",
        "Girardota",
        "Itagui",
        "La Ceja",
        "La Estrella",
        "El Retiro",
        "Rionegro",
        "Sabaneta",
    ];

    const listEducationLevelsFormationArea = [
        "Técnico",
        "Tecnólogo",
        "Universitario",
        "Especialista",
        "Maestría",
    ];

    const contentfulData = data.form.nodes[0];
    const modalSuccessCursos = data.modalSuccess.nodes[0];
    const modalSuccessVacantes = data.modalSuccessVacantes.nodes[0];
    const modalSuccessTallerCursos = data.modalSuccessTallerCursos.nodes[0];
    const modalSuccessTallerVacantes = data.modalSuccessTallerVacantes.nodes[0];
    const pantallaRegistroDuplicado = data.pantallaRegistroDuplicado.nodes[0];
    const contentfulModalWithoutAge = data.modalWithoutAge.nodes[0];
    const dataTableTalleres = JSON.parse(contentfulData.titulosFormulario[4].referenciaFormulario[3].textoTerminosMigrantes.raw);
    const Context = useContext(GlobalContext);
    const posRef = useRef<HTMLDivElement>(null);
    const { isBrowser, window } = useBrowserMode();

    const defaultFormValues = {};
    const fieldsToSkipAux:string[] = [];

    const [formValues, setFormValues] = useState<any>(defaultFormValues);
    const [municipality, setMunicipality] = useState("");
    const [departments, setDepartments] = useState([]);
    const [docNumber, setDocNumber] = useState("");
    const [loadingMentoriaAPI, setLoadingMentoriaAPI] = useState(false);
    const [continueFormMentoriaValidation, setContinueFormMentoriaValidation] = useState(true);
    const [continueCourses, setCountinueCourses] = useState(false);
    const [continueVacancies, setCountinueVacancies] = useState(false);
    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [inputDisabled, setInputDisabled] = useState<string[]>([]);
    const [fieldsToSkip, setFieldsToSkip]= useState<string[]>([]);
    const [selectedDay] = useState(null);
    const [documentType, setDocumentType] = useState("");
    const [hasFormalEmploy, setHasFormalEmploy] = useState(false);
    const [workShop, setWorkShop] = useState<any>(null);
    const [showModalCourses, setShowModalCourses] = useState(false);
    const [showModalVacancies, setShowModalVacancies] = useState(false);
    const [showModalCourses2, setShowModalCourses2] = useState(false);
    const [showModalVacancies2, setShowModalVacancies2] = useState(false);
    const [showModalAlreadyInBoth, setShowModalAlreadyInBoth] = useState(false);
    const [hasDisability, setHasDisability] = useState("");
    const [disability, setDisability] = useState("");
    const [interestedWorkshop, setinterestedWorkshop] = useState("");
    const [talleresData, setTalleresData] = useState(null);
    const [selectedModality, setSelectedModality] = useState("");
    const [duration, setDuration] = useState("");
    const [cancelForm, setCancelForm] = useState(false);
    const [, setSelectedReason] = useState("");
    const hiddenFields = {["inscrito_mentoria"]: "", ["asistencia_mentoria"]: "", ["fecha_mentoria"]: "", ["mentor"]: ""};
    const [contentfulDataHelper, setContentfulDataHelper] = useState(contentfulData);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [validBirthDate, setValidBirthDate] = useState(false);
    const [showModalWithoutAge, setShowModalWithoutAge] = useState<boolean>(false);
    const [dateStateHelper, setDateStateHelper] = useState<boolean>(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [errorConsulta, setErrorConsulta] = useState<boolean>(false);

    const setDurationState = (value: string) =>{
        setDuration(value);
    }

    let selectorStatusFormationArea: any = null;
    let selectorFormDisability: any = null;
    let selectorFormInterestedWorkshop: any = null;
    let selectorEducationLevel: any = null;
    let interestedWorkshopS: any = null;
    let interestedWorkshopN: any = null;
    let selectorTallerTable: any = null;
    let selectorWorkshopOffer: any = null;
    const pathName = isBrowser ? window.location.pathname.split('/')[5] : ''
    const registerDate = moment(Date.now()).format("DD-MM-YYYY");

    const resetFormValues = (key: string, selector: string) => {
      setFormValues((prev: any) => {
          const auxFormValues = { ...prev };
          delete auxFormValues[key];
          return auxFormValues;
      });
      const inputSel = document.querySelector(selector) || {};
      inputSel.value = "";
      inputSel["checked"] = false;
   };

    //Validaciones para los inputs
    const inputRegexValidation = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "nameContact" || field === "role") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "phone" || field === "aux_number") {
            return value.length <= 10 ? true : false;
        }
        return true;
    };

    useEffect(() => {
        selectorStatusFormationArea = document.querySelector(".a-input__form-formation_area");
        selectorFormDisability = document.querySelector(".a-input__form-disability");
        selectorFormInterestedWorkshop = document.querySelector(".a-input__form-interested_workshop");
        selectorTallerTable = document.querySelector(".a-input__form-table-select");
        selectorEducationLevel = document.getElementById("select_education_level");
        interestedWorkshopS = document.getElementById("interested_workshop_Si");
        interestedWorkshopN = document.getElementById("interested_workshop_No");
        selectorWorkshopOffer = document.querySelector(".a-input__form-workshop_offer");
    }, [formValues, talleresData])

    useEffect(() => {
      if(currentIndex === 3){
         setFormValues({...formValues, ["birth_date"]: "", ["education_level"]: ""})
      }
    }, [currentIndex]);

    // funcion para encontrar un string en un nodo especifico (lista de talleres)
    const containsText = (obj: any) => {
        // accede a la ultima columna "Discapacidad" de la tabla Talleres
        let disabilityListContentful = obj?.content?.[3]?.content?.[0]?.content?.[0]?.value || "" ;

        if (!disabilityListContentful) return false;

        const checkNode = () => {
            if (disabilityListContentful.includes(formValues.disability.toLowerCase())) {
                return true;
            }
            return false;
        };



        if (checkNode()) return true;

        if (Array.isArray(obj)) {
            return obj.some(containsText);
        } else if (typeof obj === 'object' && obj !== null) {
            return Object.values(obj).some(containsText);
        }

        return false;
    }

    const isHeaderRow = (row: any) => {
        return row.content.some((cell: any) => cell.nodeType === 'table-header-cell');
    }

    //funcion para remover Nodo padre dependiento de un String (lista de talleres)
    const removeParentWithText = (obj:any) => {
    if (Array.isArray(obj)) {
        return obj
        .map(removeParentWithText)
            .filter(item => item !== null);
        } else if (typeof obj === 'object' && obj !== null) {
            if (obj.nodeType === 'table-row' && !isHeaderRow(obj) && !containsText(obj)) {
                return null;
            }

            // Procesa recursivamente los hijos del nodo
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const result = removeParentWithText(obj[key]);
                    if (result !== null) {
                        obj[key] = result;
                    } else {
                        delete obj[key]; // Elimina la propiedad si el resultado es null
                    }
                }
            }
        }
        return obj;
    }

    const getAnswersByDocNumber = async (idForm: number) => {
        try {
            const token = await getToken();
            const response = await getUserFormDataByQuestionId(token, idForm, "docNumber", formValues.docNumber);

            if (response.status !== 200) {
                console.error("Error fetching answers by document number:", response);
                setErrorConsulta(true);
            }

            return response;
        } catch (error) {
            console.error("An error occurred while fetching answers by document number:", error);
            setErrorConsulta(true);
        }
    };

    const ValidationModal = (modalProps: any) => {
        return (
            <>
                <Modal
                    image="https://images.ctfassets.net/gkhyeghj07ak/6m03XnZihvm3nFFlJzHZDF/0e4c890b4ca48b89a1ba9b36f2dfbfd3/check-error.png?h=250"
                    title="Lo sentimos, no se pude realizar tu consulta"
                    textButton="Finalizar"
                    url={"./"}
                >
                    <div className={`o-form-aprAmva__content-modal`}>
                        <img src={iconInfo} alt="icono de info" className="o-form-aprAmva__content-modal-icon" />
                        <h2 className="o-form-aprAmva__content-modal-title">
                            {modalProps.title}
                        </h2>
                        <p>
                            {modalProps.message}
                        </p>
                    </div>
                </Modal>
            </>
        )
    }

    const updateInputValue = (field: string, value: any, type?: string) => {

        const selectorReasonNotInterested : any = document.querySelector(".a-input__form-reason_not_interested");
        const selectorAnotherReason : any = document.querySelector(".a-input__form-another_reason");

        setFormValues({ ...formValues, ...hiddenFields});
        if (inputRegexValidation(field, value)) {
            setFormValues((prev: any) => {
                return { ...prev, [field]: value };
            });
        }

        if (field == "municipalities"){
            setMunicipality(value);
            localStorage.setItem("municipality", value);
        }

        if (field == "deparment"){
            departments.find((department: any) => {
               if (department.name === value){
                  municipalitiesList(department.id);
               }
            });
        }

        if (field == "municipality_of_residence"){
            setMunicipality(value);
        }

        // Poner datos en localstorage
        if (field == "docNumber"){
            setDocNumber(value);
            localStorage.setItem("docNumber", value);
        }

        if (field == "documentType"){
            const docValues = {
                'Cédula de ciudadanía': 'CC',
                'Cédula de extranjería':'CE',
                'Tarjeta de identidad':'TI',
                'Pasaporte':'PA',
                'Permiso especial de permanencia':'PEP',
                'Documento nacional de identificacón':'DNI'
            }
            setDocumentType(docValues[value]);
        }

        if (field == "aux_number") {
            if (formValues.education_level){
                fieldsToSkipAux.push("formation_area");
            }
        }

        if (field == "birth_date") {
            if (formValues.education_level){
                fieldsToSkipAux.push("formation_area");
            }
        }

        if (field == "cellphone") {
            if (formValues.education_level){
                fieldsToSkipAux.push("formation_area");
            }
        }

        if (field == "email") {
            if (formValues.education_level){
                fieldsToSkipAux.push("formation_area");
            }
        }

        if (field == "gender") {
            if (formValues.education_level){
                fieldsToSkipAux.push("formation_area");
            }
        }

        if(field == "education_level"){
            if(selectorStatusFormationArea != undefined){
                if (!listEducationLevelsFormationArea.includes(selectorEducationLevel.value)){
                    selectorStatusFormationArea.style.visibility = 'hidden';
                    selectorStatusFormationArea.style.height = '0';
                    selectorStatusFormationArea.style.margin = '0';
                    fieldsToSkipAux.push("formation_area");
                } else {
                    selectorStatusFormationArea.style.visibility = 'visible';
                    selectorStatusFormationArea.style.height = 'auto';
                }
            }else{
               fieldsToSkipAux.push("formation_area");
            }
        }

        if (field === "has_disability") {
            resetFormValues("disability", "#select_disability");
            resetFormValues("workshop_offer", ".a-nombre-taller-input");
            setHasDisability("No");
            selectorReasonNotInterested.style.display = "none";
            formValues.reason_not_interested = "";
            selectorAnotherReason.style.display = "none";
            formValues.another_reason = "";
            if(value === "No") {
                formValues.disability = "";
                if (selectorFormDisability) {
                    selectorFormDisability.style.display = "none";
                }
                selectorFormInterestedWorkshop.style.display = "flex";
                selectorTallerTable.style.display = "none";
                fieldsToSkipAux.push("disability");
                interestedWorkshopS.checked = false;
                interestedWorkshopN.checked = false;
                setHasDisability("No");
            } else {
                formValues.disability = "";
                selectorFormInterestedWorkshop.style.display = "none";
                selectorFormDisability.style.display = "flex";
                selectorTallerTable.style.display = "none";
                setHasDisability("Si");
            }
        }

        if (field == "disability") {

            setDisability(value);
            selectorReasonNotInterested.style.display = "none";
            formValues.reason_not_interested = " ";
            interestedWorkshopS.checked = false;
            interestedWorkshopN.checked = false;

            if (value){
                selectorFormInterestedWorkshop.style.display = "flex";
            }
            selectorTallerTable.style.display = "none";
        }

        if (field == "formal_employee") {
            setDisabledButton(true);
            setLoadingMentoriaAPI(true);
            if (value == "Sí") {
                setHasFormalEmploy(true);
                getAnswersByDocNumber(6).then((answer) => {
                    if (answer.data.answerData != null && (isDateMoreThanXMonthsAgo(answer.data.creationDate, contentfulData.timeValidation || 3) == false)) {
                        setLoadingMentoriaAPI(false);
                        setShowModalVacancies(true);
                        setCountinueVacancies(true);
                    } else {
                        setDisabledButton(false);
                        setLoadingMentoriaAPI(false);
                    }
                });
            } else {
                setHasFormalEmploy(false);
                getAnswersByDocNumber(6).then((answer) => {
                    if(answer.data.answerData && answer.data.answerData.has_disability != "No"){
                        localStorage.setItem("disability", answer.data.answerData.disability);
                    }
                    if (answer.data.answerData != null && (isDateMoreThanXMonthsAgo(answer.data.creationDate, contentfulData.timeValidation || 3) == false)) {
                        setShowModalAlreadyInBoth(true);
                        getAnswersByDocNumber(8).then((response) => {
                            if (response.data.answerData != null && (isDateMoreThanXMonthsAgo(response.data.creationDate, contentfulData.timeValidation || 3) == false)) {
                                setShowModalAlreadyInBoth(true);
                                setLoadingMentoriaAPI(false)
                            } else {
                                setShowModalCourses(true);
                                setCountinueCourses(true);
                            }
                        })
                    } else {
                        setDisabledButton(false);
                        setLoadingMentoriaAPI(false)
                    }
                });
            }
        }

        if (field =="interested_workshop") {
            resetFormValues("workshop_offer", ".a-nombre-taller-input");
            resetFormValues("reason_not_interested", ".a-input__form-reason_not_interested");
            resetFormValues("another_reason", ".a-input__form-another_reason");
            setinterestedWorkshop(value);
            selectorReasonNotInterested.style.display = "none";

            if (value === "Si" && hasDisability === "No"){
                selectorTallerTable.style.display = "flex";
                let listaTalleresCp = {...dataTableTalleres};
                setTalleresData(listaTalleresCp);

                selectorReasonNotInterested.style.display = "none";
                formValues.reason_not_interested = " ";

                selectorAnotherReason.style.display = "none";
                formValues.another_reason = " ";

                fieldsToSkipAux.push("disability");
                fieldsToSkipAux.push("reason_not_interested");
                fieldsToSkipAux.push("another_reason");

            } else if (value === "Si" && hasDisability === "Si"){
                selectorTallerTable.style.display = "flex";

                selectorReasonNotInterested.style.display = "none";
                formValues.reason_not_interested = " ";

                selectorAnotherReason.style.display = "none";
                formValues.another_reason = " ";

                fieldsToSkipAux.push("reason_not_interested");
                fieldsToSkipAux.push("another_reason");

                setTalleresData(removeParentWithText(dataTableTalleres));
            }
            if(value === "No"){
               setTalleresData(null);
               selectorWorkshopOffer.style.display = "none";
               selectorReasonNotInterested.style.display = "flex";
               fieldsToSkipAux.push("workshop_offer");
               fieldsToSkipAux.push("disability");
               setDisabledButton(true)
            }
        }

        if (field == "workshop_offer") {
            resetFormValues("reason_not_interested", ".a-input__form-reason_not_interested");
            resetFormValues("another_reason", ".a-input__form-another_reason");
            fieldsToSkipAux.push("reason_not_interested");
            fieldsToSkipAux.push("another_reason");


            setSelectedModality(value.split(' ').pop().toLowerCase());
            setWorkShop(value);
            if (hasDisability === "No") {
                fieldsToSkipAux.push("disability");
            }
        }

        if (field == "reason_not_interested") {
            fieldsToSkipAux.push("workshop_offer");

            if(hasDisability === "No"){
               fieldsToSkipAux.push("disability");
            }

            setSelectedReason(value);
            if (value == "Otra") {
               selectorAnotherReason.style.display = "flex";

                if (document.getElementById("text-area-another_reason").value === "") {
                    setDisabledButton(true);
                }
            } else {
                selectorAnotherReason.style.display = "none";
                document.getElementById("text-area-another_reason").value = "";

                fieldsToSkipAux.push("another_reason");
                setDisabledButton(false)
            }
        }

        if (field == "another_reason") {
            fieldsToSkipAux.push("workshop_offer");
            setDisabledButton(false);
        }
        setFieldsToSkip(fieldsToSkipAux);

        if (hasDisability === "No") {
            fieldsToSkipAux.push("disability");
        } else {
            localStorage.setItem("disability", disability);
        }
    };

    const createPayload = () => {
        const payload: any = {
            idForm: 6,
            answers: [],
        };

        if (formValues.deparment) {
            const municipalityFullName = `${formValues.municipalities} - ${formValues.deparment}`;

            formValues.municipalities = municipalityFullName;
            formValues.municipality_of_residence = municipalityFullName;

            delete formValues.deparment;
        }

        // Delete key/values skipped from formValues
        fieldsToSkip.forEach(field => delete formValues[field]);

        if(formValues.formation_area === ""){
         delete formValues.formation_area;
        }

        Object.entries(formValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });
        return payload;
    };

    const handleSubmitForm = async () => {
        setDisabledButton(true);
        const payload = createPayload();
        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
        await saveForm(payload, token);
        setDisabledButton(false);
    };

    const matchDocumentType = (docType: string) => {
        switch (docType) {
            case "CC":
                return "Cédula de ciudadanía";
            case "DNI":
                return "Documento nacional de identificación";
            case "TI":
                return "Tarjeta de identidad";
            default:
                return "";
        }
    }

    const matchGender = (gender: string) => {
        switch (gender) {
            case "M":
                return "Hombre";
            case "F":
                return "Mujer";
            default:
                return "";
        }
    }

    const handleClickNext = async () => {
        window.scrollTo(0, 0);
        if(municipality != ""){
            if(!listCityAmva.includes(municipality) && pathName !== '/talleres-mentor'){
                redirectToTalleresRegionesMentor();
            }
            setMunicipality(municipality);
            setFormValues({
                ...formValues,
                municipality_of_residence: municipality
            });
        }
        // Carga registros de la DB-MentoriaTalento solo aplica para operación
        if(pathName === 'talleres-mentor' && currentIndex === 1){
            if(docNumber != ""){
                setLoadingMentoriaAPI(true);
                getAnswersByDocNumber(3).then((answer) => {
                    if (answer.data.answerData != null) {
                        const dataMentoriaEmpleo = answer.data.answerData;
                        setLoadingMentoriaAPI(false);
                        setFormValues({
                            ...formValues,
                            complete_name : dataMentoriaEmpleo.fullName,
                            email: dataMentoriaEmpleo.email,
                            gender: dataMentoriaEmpleo.gender,
                            document_type: dataMentoriaEmpleo.documentType,
                            doc_number: dataMentoriaEmpleo.docNumber,
                        });
                        setInputDisabled(["documentType", "doc_number", "complete_name"]);
                    } else {
                        setFormValues({
                            ...formValues,
                            document_type: formValues.documentType,
                            doc_number: formValues.docNumber,
                        });
                        setLoadingMentoriaAPI(false);
                    }
                });

            }
        }

        if (pathName === 'talleres') {
            if(municipality != "" && !listCityAmva.includes(municipality)){
                redirectToTalleresRegiones();
            }

            if(docNumber != ""){
                setLoadingMentoriaAPI(true);
                try {
                    const responseJson = await getSchedulingMentoria(docNumber, documentType);
                    if (responseJson.status !== 200) {
                        setErrorConsulta(true); 
                        return;
                    } else {
                        if (responseJson.data.status == 200) {
                            const dataSorted = responseJson.data.data.sort((a, b) => {
                                return new Date(b.schedulingDate).getTime() - new Date(a.schedulingDate).getTime();
                            });
                        
                            const dateMentoria = new Date(dataSorted[0].schedulingDate);
                            const today = new Date();
                            today.setFullYear(today.getFullYear() - 3); // hace 3 años
                        
                            if (dateMentoria.getTime() > today.getTime()) {
                                setLoadingMentoriaAPI(false);
                                const secondName = dataSorted[0].secondName ?? "";
                        
                                setFormValues({
                                    ...formValues,
                                    documentType: matchDocumentType(dataSorted[0].documentType),
                                    docNumber: dataSorted[0].docNumber,
                                    complete_name: dataSorted[0].firstName + " " + secondName + " " + dataSorted[0].lastName + " " + dataSorted[0].secondLastName,
                                    document_type: matchDocumentType(dataSorted[0].documentType),
                                    email: dataSorted[0].email,
                                    gender: matchGender(dataSorted[0].gender),
                                    doc_number: dataSorted[0].docNumber,
                                });
                        
                                setInputDisabled(["documentType", "doc_number", "complete_name", "document_type", "municipality_of_residence"]);
                                setDocNumber("");
                            } else {
                                setLoadingMentoriaAPI(false);
                                setContinueFormMentoriaValidation(false);
                            }
                        }else{
                            setLoadingMentoriaAPI(false);
                            setContinueFormMentoriaValidation(false);
                        }
                    }
                } catch (error) {
                    console.error("Error fetching scheduling data:", error);
                    setErrorConsulta(true);
                }

                
            }
        } else {
            console.info('Path ', pathName);
        }


        //No tiene empleo, tiene discapacidad, no le interesa
        if (interestedWorkshop == "No" && hasDisability != null && !hasFormalEmploy) {
            setCountinueCourses(true);
            setShowModalCourses(true);
        }

        // No tiene empleo, no le interesa
        if (interestedWorkshop == "No" && !hasFormalEmploy) {
            setCountinueCourses(true);
            setShowModalCourses(true);
        }

        // No tiene empleo, le interesa curso
        if (interestedWorkshop != "No" && !hasFormalEmploy && workShop != null) {
            setShowModalCourses2(true);
            setCountinueCourses(true);
        }

        //tiene empleo, no le interesa
        if (interestedWorkshop == "No" && hasFormalEmploy){
            setCountinueVacancies(true);
            setShowModalVacancies(true);
        }

        //Tiene empleo, tiene discapacidad, no le interesa
        if (interestedWorkshop == "No" && hasDisability != null && hasFormalEmploy) {
            setCountinueVacancies(true);
            setShowModalVacancies(true);
        }

        //tiene empleo, le interesa
        if (interestedWorkshop != "No" && hasFormalEmploy && workShop != null) {
            setShowModalVacancies2(true);
            setCountinueVacancies(true);
        }

        if (isBrowser) {
            window.scrollTo({
                top: 100,
                behavior: "smooth",
            });
        }
    }

    const departmentsList = async () => {
        try {
            const departmentsResp = await getAllDepartments();
            setDepartments(departmentsResp.data.data);

            const departments = [];

            Object.entries(departmentsResp.data.data).forEach(
                ([key, value]) => {
                    departments.push(value.name);
                }
            );

            Object.entries(
                contentfulDataHelper.titulosFormulario[0].referenciaFormulario
            ).forEach(([key, value]) => {
                if (value.nombreId === "deparment") {
                    contentfulDataHelper.titulosFormulario[0].referenciaFormulario[
                        key
                    ].listaSelect = departments;
                }
            });
        } catch (error) {
            console.log("API Error:", error);
        }
    };

    const municipalitiesList = async (departmentId: number) => {
        try {
            const municipalitiesResp = await getMunicipalities(departmentId);
            const municipalities = Object.values(
                municipalitiesResp.data.data
            ).map((mun) => mun.name);

            setContentfulDataHelper((prevData) => {
                const newData = { ...prevData };

                const updateSelectList = (
                    formIndex: number,
                    fieldId: string
                ) => {
                    const referenciaFormulario =
                        newData.titulosFormulario[formIndex]
                            .referenciaFormulario;
                    const field = Object.values(referenciaFormulario).find(
                        (value) => value.nombreId === fieldId
                    );
                    if (field) {
                        field.listaSelect = municipalities;
                    }
                };

                updateSelectList(0, "municipalities");
                updateSelectList(3, "municipality_of_residence");

                return newData;
            });
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    useEffect(() => {
        setFormValues({ ...formValues, ["registerDate"]: registerDate });
        departmentsList();
    }, []);

    const closeForm = () => {
        navigate(`https://www.comfama.com/servicio-de-empleo/personas/aprendizaje/`);
    };

    const closeCancelForm = () => {
        setCancelForm(false);
    };

    const redirectToFormMentoria = () => {
        navigate("https://www.comfama.com/servicio-de-empleo/personas/mentoria-de-talento/");
    };

    const redirectToPersonas = () => {
        navigate("https://www.comfama.com/servicio-de-empleo/personas/");
    };

    const redirectToTalleresRegionesMentor = () => {
        navigate("https://www.comfama.com/servicio-de-empleo/personas/aprendizaje/formulario/talleres-regiones-mentor/");
    }
    const redirectToTalleresRegiones = () => {
        navigate("https://www.comfama.com/servicio-de-empleo/personas/aprendizaje/formulario/talleres-regiones/");
    }

    const handleCancelModal = () => {
      setShowCancelModal(true);
    }

    useEffect(() => {
        if (formValues.birth_date) {
            let yearDiff = new Date().getUTCFullYear() - Number(formValues.birth_date.split('-')[2]);

            if ( yearDiff >= 16 ) {
                setValidBirthDate(true);
                setFormValues({...formValues, ["education_level"]: "", ["formation_area"]: ""})
            } else {
                setShowModalWithoutAge(true);
                setValidBirthDate(false);
                setDateStateHelper(true)
                setFormValues({...formValues, ["birth_date"]: "", ["education_level"]: "", ["formation_area"]: ""})
            }
        }
    }, [formValues.birth_date]);

    return (
        <>
            <div className="m-section-form-taller-aprendizaje" ref={posRef}>
                { continueFormMentoriaValidation && !continueCourses && !continueVacancies && !showModalAlreadyInBoth && (
                    <>
                    <FormHead
                        tituloPrincipal={contentfulDataHelper.tituloPrincipal}
                        descripcion={contentfulDataHelper.descripcion}
                        tituloFormulario={
                            contentfulDataHelper.tituloFormulario
                        }
                        descripcionFormulario={
                            contentfulDataHelper.descripcionFormulario.json
                        }
                    ></FormHead>
                    <FormBody
                        // Campos y estilos del formulario
                        titulosFormulario={
                            contentfulDataHelper.titulosFormulario
                        }
                        genericClassNameForm={contentfulDataHelper.metaTitulo}
                        setInputValue={updateInputValue}
                        formValues={formValues}
                        handleSubmitForm={handleSubmitForm}
                        inputDisabled={inputDisabled}
                        isDisabledButton={isDisabledButton}
                        handleEvent={handleClickNext}
                        dateState={selectedDay}
                        fieldsToSkip={fieldsToSkip}
                        talleresData={talleresData}
                        setDuration={setDurationState}
                        validBirthDate={validBirthDate}
                        dateStateHelper={dateStateHelper}
                        setDateStateHelper={setDateStateHelper}
                        setCurrentIndex={setCurrentIndex}
                    >
                     <button
                           className={`boton-cancelar`}
                           onClick={() => handleCancelModal()}
                     >
                           Cancelar
                     </button>
                        {loadingMentoriaAPI && (
                            <div className="loader-form">
                                <span>Validando información, espere por favor...</span>
                                <CircularProgress size={100} thickness={6} color="secondary" className="loader-form-circle"/>
                            </div>
                        )}
                        {cancelForm && (
                             <Modal
                             showModal={cancelForm}
                             onClose={closeCancelForm}>
                                 <div
                                     className={`m-modal-container-validation`}
                                 >
                                    <h3>¿Estás seguro que quieres cancelar el proceso de inscripción?</h3>
                                    <div className="a-button-magenta-container__modal-cancelar">
                                       <Button
                                          type="button"
                                          classname="a-button-magenta"
                                          text={"NO, QUIERO REGRESAR"}
                                          isDisabled={false}
                                          onClickAction={() => {
                                                closeCancelForm()
                                          }}
                                       >
                                       </Button>
                                    </div>
                                 <div>
                                     <Button
                                            type="button"
                                            classname="a-button-magenta__cancelar-modal"
                                            text={"SÍ QUIERO"}
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeForm()
                                            }}
                                       >
                                    </Button>
                                     </div>
                                 </div>
                         </Modal>
                        )}
                    </FormBody>
                    </>
                )}
                {!continueFormMentoriaValidation && (
                    <div className={`m-modal-container-validation`} >
                    <Modal
                        showModal={true}
                        onClose={closeForm}>
                        <div className={`m-modal-container-validation`} >
                            <h3>¡Ups! Aún no has participado en Mentoría de Talento</h3>
                            <div className="m-modal-container-validation__paragraph">
                                <p>Si ya participaste, debes esperar 24 horas para realizar tu registro a la oferta de talleres y cursos.</p>
                            </div>
                            <div className="m-modal-container-validation__paragraph">
                                <p>Recuerda que es necesario asistir a la Mentoría de Talento para acceder a la oferta de aprendizaje. Si aún no la has realizado, inscríbete para iniciar el proceso.</p>
                            </div>

                            <div className="m-modal-container-validation__button">
                                <Button
                                    type="button"
                                    classname="a-button-magenta-container__modal-cancelar"
                                    text={"Cancelar"}
                                    isDisabled={false}
                                    onClickAction={() => {
                                        closeForm()
                                    }}
                                >
                                </Button>
                                <Button
                                    type="button"
                                    classname="a-button-magenta"
                                    text={"Inscribirme"}
                                    isDisabled={false}
                                    onClickAction={() => {
                                        redirectToFormMentoria()
                                    }}
                                    gtmMark="gtm_form_click_boton_inscripcion_mentoria"
                                    data="No ha participado en mentoria (Form aprendizaje)"
                                    >
                                </Button>
                            </div>
                        </div>
                    </Modal>
                    </div>
                )}
                {showModalCourses && (
                    <div className="container-modal-talleres">
                        <div className="a-modal-continue-taller-left__inscripcion-cursos courses">
                            <div className="courses__text-container">
                                <h1 className="a-modal-continue-taller-left__description courses__title">{modalSuccessCursos.tituloPrincipal}</h1>
                                <p className="a-modal-continue-taller-left__aux-text courses__description">{rawToReact(modalSuccessCursos.descripcionFormulario.raw,contentfulRenderOptions)}</p>
                            </div>
                            <div className="courses__alert">
                                <img
                                    className="courses__alert__icon"
                                    alt="alert icon"
                                    src={iconInfo}
                                />
                                <span className="courses__alert__text">
                                    Para acceder a los cursos, debes estar actualmente sin empleo y haber realizado aportes los últimos 3 años a Caja de Compensación Familiar, acumulando un período total de cotización de 1 año como trabajador dependiente y de 2 años como independiente. Asistiendo a nuestros cursos estarás cumpliendo con uno de los requisitos para aplicar al
                                    <strong className="subsidio-modal">
                                        <a href="https://www.comfama.com/servicio-de-empleo/personas/subsidio-de-desempleo/" target="_blank" rel="noopener noreferrer">&nbsp;Subsidio al desempleo.</a>
                                    </strong>
                                </span>
                            </div>
                            <div>
                                <Button
                                    type="link"
                                    text={modalSuccessCursos.tituloBoton}
                                    href={modalSuccessCursos.redireccionBoton}
                                    isDisabled={false}
                                    classname="a-modal-continue-taller-left__button"
                                    gtmMark="gtm_form_click_boton_inscripcion_cursos"
                                    data="No tiene talleres"
                                />
                            </div>
                        </div>
                    </div>
                )}
                {showModalVacancies && (
                    <div className="container-modal-talleres">
                        <div className="a-modal-continue-taller-left">
                            <div className="div1">
                                <div>
                                    <h1 className="a-modal-continue-taller-left__description">{modalSuccessVacantes.tituloPrincipal}</h1>
                                    {rawToReact(modalSuccessVacantes.descripcionFormulario.raw,contentfulRenderOptions)}
                                </div>
                                <div>
                                    <Button
                                        type="link"
                                        text={modalSuccessVacantes.tituloBoton}
                                        href={modalSuccessVacantes.redireccionBoton}
                                        isDisabled={false}
                                        classname="a-modal-continue-taller-left__button-vacancies-white"
                                        gtmMark="gtm_form_click_boton_ver_vacantes_sin_interes_taller"
                                        data="Sin interés (Ruta de aprendizaje)"
                                    />
                                    <Button
                                        type="link"
                                        text={"CONOCE NUESTROS SERVICIOS"}
                                        href={"https://www.comfama.com/servicio-de-empleo/personas/"}
                                        isDisabled={false}
                                        classname="a-modal-continue-taller-left__button"
                                        gtmMark="gtm_form_click_boton_home_personas_sin_interes_taller"
                                        data="Sin interés (Ruta de aprendizaje)"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="a-modal-continue-taller-right" id="a">
                            <img className="a-modal-continue-taller-right__image" src={modalSuccessVacantes.imagenFormulario.file.url} />
                        </div>
                    </div>
                )}
                {showModalCourses2 && (
                    <div className="container-modal-talleres">
                        <div className="a-modal-continue-taller-left__inscripcion-cursos">
                            <div className="courses__text-container">
                                <h1 className="a-modal-continue-taller-left__description courses__title">{modalSuccessTallerCursos.tituloPrincipal}</h1>
                                <p className="a-modal-continue-taller-left__aux-text courses__description">{rawToReact(modalSuccessTallerCursos.descripcionFormulario.raw,contentfulRenderOptions)}</p>
                            </div>
                            <div className="a-modal-continue-taller-taller">
                                <div className="a-modal-continue-taller-taller__title">
                                    <p>Taller:</p>
                                </div>
                                <div className="a-modal-continue-taller-taller__description">
                                    <div className="__taller-modality">
                                        <p>Modalidad:</p> <span>{selectedModality.charAt(0).toUpperCase() + selectedModality.slice(1)}</span>
                                    </div>
                                    <div className="__taller-description">
                                        <p>{ showModalCourses2 ? "Taller:" : "Curso:"}</p> {workShop && (<span>{workShop.substring(0, workShop.lastIndexOf(" ")) + " " + duration}</span>)}
                                    </div>
                                </div>
                            </div>
                            <div className="a-modal-continue-taller-aux-text">
                                <p className="a-modal-continue-taller-left__aux-text"><b>{modalSuccessTallerCursos.auxText}</b></p>
                            </div>
                            <div className="courses__alert">
                                <img
                                    className="courses__alert__icon"
                                    alt="alert icon"
                                    src={iconInfo}
                                />
                                <span className="courses__alert__text">
                                    Para acceder a los cursos, debes estar actualmente sin empleo y haber realizado aportes los últimos 3 años a Caja de Compensación Familiar, acumulando un período total de cotización de 1 año como trabajador dependiente y de 2 años como independiente. Asistiendo a nuestros cursos estarás cumpliendo con uno de los requisitos para aplicar al
                                    <strong className="subsidio-modal">
                                        <a href="https://www.comfama.com/servicio-de-empleo/personas/subsidio-de-desempleo/" target="_blank" rel="noopener noreferrer">&nbsp;Subsidio al desempleo.</a>
                                    </strong>
                                </span>
                            </div>
                            <div>
                                <Button
                                    type="link"
                                    text={modalSuccessTallerCursos.tituloBoton}
                                    href={modalSuccessTallerCursos.redireccionBoton}
                                    isDisabled={false}
                                    classname="a-modal-continue-taller-left__button"
                                    gtmMark="gtm_form_click_boton_inscribirme_a_cursos"
                                    data={workShop}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {showModalVacancies2 && (
                    <div className="container-modal-talleres">
                        <div className="a-modal-continue-taller-left__inscripcion-cursos">
                            <div>
                                <h1 className="a-modal-continue-taller-left__description">{modalSuccessTallerVacantes.tituloPrincipal}</h1>
                                <p className="a-modal-continue-taller-left__aux-text">{rawToReact(modalSuccessTallerVacantes.descripcionFormulario.raw,contentfulRenderOptions)}</p>
                            </div>
                            <div className="a-modal-continue-taller-taller">
                                <p>Taller {selectedModality}:</p>
                                {workShop && (<span>{workShop.substring(0, workShop.lastIndexOf(" ")) + " " + duration}</span>)}
                            </div>
                            <div>
                                <Button
                                    type="link"
                                    text={modalSuccessTallerVacantes.tituloBoton}
                                    href={modalSuccessTallerVacantes.redireccionBoton}
                                    isDisabled={false}
                                    classname="a-modal-continue-taller-left__button-vacancies-white"
                                    gtmMark="gtm_form_click_boton_bienvenida_talleres_ver_vacantes"
                                    data={workShop}
                                />
                                <Button
                                    type="link"
                                    text={"CONOCE NUESTROS SERVICIOS"}
                                    href={"https://www.comfama.com/servicio-de-empleo/personas/"}
                                    isDisabled={false}
                                    classname="a-modal-continue-taller-left__button"
                                    gtmMark="gtm_form_click_boton_home_personas_con_interes_taller"
                                    data="Conoce Nuestros Servicios"
                                />
                            </div>
                        </div>
                        <div className="a-modal-continue-taller-right" id="a">
                            <img className="a-modal-continue-taller-right__image" src={modalSuccessTallerVacantes.imagenFormulario.file.url} />
                        </div>
                    </div>
                )}
                {showModalAlreadyInBoth && (
                    <div className="container-modal-talleres both">
                        <img src={pantallaRegistroDuplicado.imagenFormulario.file.url} alt="icono alerta modal" />
                        <h1 className="a-modal-continue-talleres-left__description">{pantallaRegistroDuplicado.tituloPrincipal}</h1>
                        <span>{rawToReact(pantallaRegistroDuplicado.descripcion.raw,contentfulRenderOptions)}</span>
                        <div className="a-modal-continue-talleres-taller__buttons">
                            <Button
                                type="link"
                                text={pantallaRegistroDuplicado.tituloBoton}
                                href={pantallaRegistroDuplicado.redireccionBoton}
                                isDisabled={false}
                                classname="a-button-magenta"
                                onClickAction={() => {
                                    redirectToPersonas()
                                }}
                            />
                        </div>
                    </div>
                )}
                {showCancelModal && (
                  <Modal
                     showModal={showCancelModal}
                     onClose={() => {
                           setShowCancelModal(false);
                     }}
                  >
                     <div className={`m-modal-container-cancelation`}>
                           <h3>
                              ¿Estás seguro que quieres cancelar el proceso de
                              inscripción?
                           </h3>

                           <div className="a-button-magenta-container__modal-cancelar">
                              <Button
                                 type="button"
                                 classname="a-button-magenta"
                                 text={"NO, QUIERO REGRESAR"}
                                 isDisabled={false}
                                 onClickAction={() => setShowCancelModal(false)}
                              ></Button>
                           </div>
                           <div>
                              <Button
                                 type="button"
                                 classname="m-modal-content__buttonbar__cancel"
                                 text={"SÍ QUIERO"}
                                 isDisabled={false}
                                 onClickAction={() =>
                                       navigate(
                                          "https://www.comfama.com/trabajo-con-proposito/empleo/aprendizaje-y-desarrollo/"
                                       )
                                 }
                              ></Button>
                           </div>
                     </div>
                  </Modal>
               )}
               {showModalWithoutAge && (
                    <Modal
                    showModal={showModalWithoutAge}
                    onClose={() => setShowModalWithoutAge(false)}
                    >
                        <div className={`m-modal-container-validationMpc`}>
                            <img
                                src={contentfulModalWithoutAge.imagenFormulario.file.url}
                                className="o-verification-mpc-response__img"
                                alt="Success"
                            ></img>
                            <h3> {contentfulModalWithoutAge.tituloPrincipal} </h3>
                            <div className="m-modal-container-validationMpc__paragraph">
                                <p>
                                    {rawToReact(
                                        contentfulModalWithoutAge.descripcionFormulario.raw,
                                        contentfulRenderOptions
                                    )}
                                </p>
                            </div>
                            <Button
                                type="button"
                                classname="a-button__magenta"
                                onClickAction={() => {
                                    setShowModalWithoutAge(false)}}
                                isDisabled={false}
                                text={contentfulModalWithoutAge.tituloBoton}
                            />


                        </div>
                    </Modal>
                )}
                {errorConsulta && ( 
                    <ValidationModal
                        title="Lo sentimos, no se pude completar tu consulta en nuestras bases de datos"
                        textButton="Entendido"
                        message = "Tenemos alto trafico de consultas, por favor intenta más tarde."
                        
                    />
                )}
            </div>
        </>
    );
};

export default FormTallerAprendizaje;
